import { FormControl, Select, MenuItem, InputLabel, Tooltip } from "@mui/material";
import React from "react";
import "./header.style.css";
import ConfirmationModal from "../../../common/components/ConfirmationModal";

export function LocationGroups({
  currentlocationGroup,
  allLocationGroups,
  onGroupLocationChange,
}) {
  
  const [selectedLocationGroup, setSelectedLocationGroup] = React.useState<any>(currentlocationGroup);
  const [pendingLocationGroup, setPendingLocationGroup] = React.useState<any>(null);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const handleLocationChange = (value: any) => {
    setPendingLocationGroup(value);   // store temporarily until confirmed
    setModalOpen(true);
  };

  const handleConfirmChange = () => {
    setSelectedLocationGroup(pendingLocationGroup);
    onGroupLocationChange(pendingLocationGroup);
    setPendingLocationGroup(null);
    setModalOpen(false);
  };

  const handleCancelChange = () => {
    setPendingLocationGroup(null);
    setModalOpen(false);
  };


  return (
    <>
      <FormControl className="location-groups-form">
        <InputLabel id="white-dropdown-label">Location Group</InputLabel>
        <Tooltip
          title={dropdownOpen ? "" : selectedLocationGroup?.name || ""}
          placement="top"
          arrow
        >
          <div>
            <Select
              className="location-groups-select"
              labelId="white-dropdown-label"
              id="demo-simple-select-location-groups"
              label="Location Group"
              value={selectedLocationGroup || ""}
              onChange={(e) => handleLocationChange(e.target.value)}
              onOpen={() => setDropdownOpen(true)}
              onClose={() => setDropdownOpen(false)}
              renderValue={(selected) =>
                selected && selected.name ? (
                  <span style={{
                    display: 'inline-block',
                    maxWidth: 280,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    verticalAlign: 'bottom'
                  }}>
                    {selected.name}
                  </span>
                ) : ''
              }
            >
              {allLocationGroups?.map((location: any, index) => (
                <MenuItem key={index} sx={{ fontSize: "small" }} value={location}>
                    {location.name}
                </MenuItem>
              ))}
            </Select>
          </div>
        </Tooltip>
          </FormControl>

      <ConfirmationModal
        open={isModalOpen}
        onClose={handleCancelChange}
        heading="Confirm Location Group Change"
        confirmationText="This action will update your location group. Do you want to continue?"
        confirmationButtonText="Proceed"
        onConfirm={handleConfirmChange}
      />
    </>
  );
}
